import { useCallback, useEffect, useState } from 'react'
import { Check2Square, Square } from 'react-bootstrap-icons'
import Questionnaire from '../../../../../libs/api/services/Questionnaire'
import QBuilderAdvancedOptionsEventTrigger from './Options/QBuilderAdvancedOptionsEventTrigger'

export default function QBuilderAdvancedOptions({ title, description, navigation, navigator, errors, setValue, values }) {
    const [options, setOptions] = useState(null)

    const fetchOptions = useCallback(async () => {
        try {
            const res = await Questionnaire.GetOptions(values.questionnaireId)
            setOptions(res)
        } catch (e) {
            // swallow network errors for now (consistent with previous behaviour)
        }
    }, [values.questionnaireId])

    const setOption = useCallback(async (name, option) => {
        try {
            await Questionnaire.SetOption(values.questionnaireId, { name, value: JSON.stringify(option) })
        } catch (e) {
            // ignore errors as before
        }
    }, [values.questionnaireId])

    const getOption = useCallback((name) => {
        if (!options) return undefined
        const found = options.find(o => o.name === name)
        if (!found) return undefined
        try { return JSON.parse(found.value) } catch { return undefined }
    }, [options])

    useEffect(() => { fetchOptions() }, [fetchOptions])

    // run once on mount - navigation prop may be recreated by parent and cause loops
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        title('Additional Options')
        description('')
        navigation([
            { text: 'Back', type: 'Step', step: 3 },
            { text: 'Done', type: 'Done', action: async () => { } }
        ])
    }, [])

    const handleToggle = async (name) => {
        const opt = getOption(name)
        const current = !!(opt && opt.value === true)
        await setOption(name, { value: !current })
        await fetchOptions()
    }

    const keepEnabled = getOption('ON_COMPLETE_KEEP')?.value === true
    const triggerEnabled = getOption('ON_COMPLETE_TRIGGER_EVENT')?.value === true

    const handleKeyToggle = (e, name) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleToggle(name)
        }
    }

    return (
        <div className='text-start m-3'>
            <div className='p-2 rounded'>
                <label><b>Once Questionnaire Completed</b></label>
                <div className='row'>
                    <div
                        role='button'
                        tabIndex={0}
                        onKeyDown={(e) => handleKeyToggle(e, 'ON_COMPLETE_KEEP')}
                        onClick={() => handleToggle('ON_COMPLETE_KEEP')}
                        className={`bg-primary-container col-4 p-2 rounded m-2 shadow ${keepEnabled ? '' : 'opacity-50'}`}>
                        {keepEnabled ? <Check2Square className='me-2' /> : <Square className='me-2' />}
                        <b>Keep questionnaire on patients questionnaire list</b>
                        <div className='ms-3 mt-1'>
                            <p>This will not remove the questionnaire from the patients list and allow them to make changes at a later stage even if completed</p>
                        </div>
                    </div>

                    <div className={`bg-primary-container col-4 p-2 rounded m-2 shadow `}>
                        <div
                            role='button'
                            tabIndex={0}
                            onKeyDown={(e) => handleKeyToggle(e, 'ON_COMPLETE_TRIGGER_EVENT')}
                            onClick={() => handleToggle('ON_COMPLETE_TRIGGER_EVENT')}
                        >
                            {/* {triggerEnabled ? <Check2Square className='me-2' /> : <Square className='me-2' />} */}
                            <b>Trigger off an event</b>
                            <div className='ms-3 mt-1'>
                                <p className='me-2'>This will trigger off a patient event once questionnaire has been completed</p>
                            </div>
                        </div>

                        {triggerEnabled && (
                            <QBuilderAdvancedOptionsEventTrigger
                                onChangeCategory={(c) => setOption('ON_COMPLETE_TRIGGER_EVENT_CATEGORY', c)}
                                onChangeEvent={(c) => setOption('ON_COMPLETE_TRIGGER_EVENT_EVENT', c)}
                                cat={getOption('ON_COMPLETE_TRIGGER_EVENT_CATEGORY')}
                                evt={getOption('ON_COMPLETE_TRIGGER_EVENT_EVENT')}
                                values={values} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}